import { useEffect, useState } from 'react';

import {
  ALL_TRELLO_JIRA_CO_USERS,
  getUserTraits,
  useIsOptimizedUserTraitsEnabled,
  useUserTrait,
} from '@trello/atlassian-personalization';
import { useAaId, useMemberId } from '@trello/authentication';
import { getDateBefore, idToDate } from '@trello/dates';
import { useDynamicConfig } from '@trello/dynamic-config';
import { sendErrorEvent } from '@trello/error-reporting';

export const useIsSmartListCreationEnabled = () => {
  const [isJiraCoUser, setIsJiraCoUser] = useState(false);
  const memberId = useMemberId();
  const aaId = useAaId();
  // Two days until new users are included in traits
  const isNewUser = idToDate(memberId) > getDateBefore({ days: 2 });
  const isInternalAtlassian = useDynamicConfig('trello_web_atlassian_team');
  const isOptimizedUserTraitsEnabled = useIsOptimizedUserTraitsEnabled();
  const { value: isJiraCoUserTrait, loading } = useUserTrait(
    ALL_TRELLO_JIRA_CO_USERS,
  );

  useEffect(() => {
    const getTrait = async () => {
      try {
        if (isOptimizedUserTraitsEnabled) {
          if (!loading) {
            setIsJiraCoUser(Boolean(isJiraCoUserTrait));
          }
        } else {
          if (!aaId) {
            return;
          }
          const traits = await getUserTraits(aaId);
          setIsJiraCoUser(Boolean(traits[ALL_TRELLO_JIRA_CO_USERS]));
        }
      } catch (error) {
        sendErrorEvent(error, {
          tags: {
            ownershipArea: 'trello-enterprise',
            feature: 'Smart List',
          },
        });
      }
    };

    if (!isNewUser) {
      getTrait();
    }
  }, [
    aaId,
    isNewUser,
    isJiraCoUserTrait,
    isOptimizedUserTraitsEnabled,
    loading,
  ]);

  return isJiraCoUser || isInternalAtlassian;
};
